import { path as rootPath } from "../path";

import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const availabilityTimeRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.availabilityTime.route,
      lazy: () => import("@pages/panelPages/availabilityTime/availabilityTime"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.availabilityTime", [], "index", "main");
        return {};
      },
    },
    permissions: ["doctor"],
  },
  {
    route: {
      path: path.availabilityTimeById.route,
      lazy: () => import("@pages/panelPages/availabilityTime/availabilityTime"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.availabilityTime",
          [
            {
              title: "pageTitle.myDoctors",
              url: rootPath.myDoctors.myDoctors.link(),
            },
          ],
          "index",
        );
        return {};
      },
    },
    permissions: ["staff"],
  },
];
